import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ModelComponentPositionList from './ModelComponentPositionList';
import { getUserProfileWidget, getModelComponentPositionManagerWithParentList, getUserOrgModelCategoryType } from '../../selectors/index';

import {
  getModelComponentPositionThunk,
  saveModelComponentPositionThunk,
  setModelComponentPositionChangeThunk,
  setCurrentPage,
  setPageFilter,
  setModelComponentPositionFilteredDataThunk,
  resetModelComponentThunk
} from '../../actions/modelComponentPositions';

const mapStateToProps = state => {
  return {
    modelComponentPositionManager: getModelComponentPositionManagerWithParentList(state),
    userProfileWidgets: getUserProfileWidget(state),
    userModelCategories: getUserOrgModelCategoryType(state)

  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setCurrentPage: currentPage => setCurrentPage(currentPage),
      setPageFilter: filter => setPageFilter(filter),
      getModelComponentPosition: (offset, limit, filter, modelCategoryId) =>
        getModelComponentPositionThunk({ offset, limit, filter }, 'MODELCOMPONENTPOSITION_LIST', modelCategoryId),
      saveModelComponentPosition: (modelComponentPosition, widgetCode) =>
        saveModelComponentPositionThunk(modelComponentPosition, widgetCode),
      setModelComponentPositionChange: selectedModelComponentPosition =>
        setModelComponentPositionChangeThunk(selectedModelComponentPosition),
      setFilterData: filteredData => setModelComponentPositionFilteredDataThunk(filteredData),
      resetModelComponent: modelComponentPosition => resetModelComponentThunk(modelComponentPosition)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ModelComponentPositionList);
